import type { ReactNode } from 'react';

import { cx } from '@/utils/cx';

interface CardProps {
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
}

export function Card({ children, footer, className }: CardProps) {
  return (
    <div
      className={cx(
        'rounded-xl border border-secondary bg-primary',
        !footer && 'p-4',
        className,
      )}
    >
      {footer ? (
        <>
          <div className="p-4">{children}</div>
          <div className="border-t border-secondary p-4">{footer}</div>
        </>
      ) : (
        children
      )}
    </div>
  );
}
